import { Checkbox, Typography } from '@fox/atoms';
import { FlexRowSpaced } from '@fox/layout';
import React from 'react';
import { SwiftFoxSubscription } from '../contracts';
export function SubscriptionSelector({
	selectedSubscriptionIds,
	setSelectedSubscriptionIds,
	subscriptions,
	paymentMethodId
}: {
	selectedSubscriptionIds: string[];
	setSelectedSubscriptionIds: React.Dispatch<React.SetStateAction<string[]>>;
	subscriptions: SwiftFoxSubscription[];
	paymentMethodId?: string;
}) {
	if (subscriptions.length < 2) return <></>;
	return (
		<>
			<Typography>Select which subscription(s) you want to use this payment method for.</Typography>
			<FlexRowSpaced style={{ flexWrap: 'wrap' }}>
				{subscriptions.map(s => {
					return (
						<FlexRowSpaced style={{ alignItems: 'center' }} key={s.id}>
							<Checkbox
								disabled={s.creditCardId === paymentMethodId || s.directDebitId === paymentMethodId}
								size="medium"
								checked={selectedSubscriptionIds.includes(s.id)}
								onChange={(_, checked) => {
									if (checked) {
										setSelectedSubscriptionIds(prev => [...prev, s.id]);
									} else {
										setSelectedSubscriptionIds(prev => prev.filter(p => p !== s.id));
									}
								}}
							/>
							<Typography>{s.fee.plan.name}</Typography>
						</FlexRowSpaced>
					);
				})}
			</FlexRowSpaced>
		</>
	);
}
